import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "../pages/HomePage";
import ModelViewer from "../components/ModelViewer";

const MainRoutes = () => {

    return (
        <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/xeokit-viewer" element={<ModelViewer />} />
        </Routes>
    );

};

export default MainRoutes;